<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="!orderParent" prop="orderId" label="关联标书">
              <el-select v-model="formData.orderId" clearable filterablex placeholder="请选择采购类型" @change="onBidChange">
                <el-option v-for="(item) of bidDucomentList" :value="item.bidId" :label="item.bidTitle"
                  :key="item.bidId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaser" label="采购方">
              <!-- <el-input :disabled="true" v-model="purchaserName" placeholder="请输入采购方" /> -->
              <el-select :disabled="!!formData.orderId" v-model="formData.purchaser" clearable filterable placeholder="请选择采购方">
                <el-option v-for="(item) of userList" :value="item.userId" :label="item.userName"
                  :key="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaserType" label="采购类型">
              <el-radio-group v-model="formData.purchaserType">
                <el-radio :label="key" v-for="[key, value] of purchaserTypeMap" :key="key">{{ value }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.purchaserType === '2'">
            <el-form-item prop="purchaserCompany" label="外销单位">
              <el-input v-model="formData.purchaserCompany" placeholder="请输入外销单位" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderTitle" label="合同标题">
              <el-input v-model="formData.orderTitle" placeholder="请输入合同标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderNum" label="合同编号">
              <el-input v-model="formData.orderNum" placeholder="请输入合同编号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierId" label="供应商">
              <el-select :disabled="!!orderParent" v-model="formData.supplierId" filterable placeholder="请选择供应商">
                <el-option v-for="(item) of supplierList" :value="item.userId" :label="item.userName"
                  :key="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderPrice" label="付款方式">
              <el-radio-group v-model="formData.orderPrice">
                <el-radio :label="key" v-for="[key, value] of orderPriceMap" :key="key">{{ value }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderType" label="订单类型">
              <el-radio-group :disabled="formData.orderParent !== '1'" v-model="formData.orderType">
                <el-radio :label="key" v-for="[key, value] of orderTypeMap" :key="key">{{ value }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="specList" label="规格">
            <el-button class="mb15" type="primary" @click="addSpecList">新增规格</el-button>
            <el-table :data="formData.specList">
              <!-- <el-table-column prop="" label="采购类型">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.purchaseType`"
                    :rules="[{ required: true, message: '请选择采购类型' }]">
                    <el-select :disabled="!!orderParent" v-model="row.purchaseType"
                      @change="res => changeType(row, res)" placeholder="请选择采购类型">
                      <el-option v-for="[key, value] of purchaseTypeMap" :value="key" :label="value"
                        :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
</el-table-column> -->
              <el-table-column key="heihei1" v-if="formData.orderParent !== '1'" prop="specId" label="规格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.specId`" :rules="[{ required: true, message: '请选择规格' }]">
                    <el-select v-model="row.specId" clearable filterable placeholder="请选择规格"
                      @change="res => onChildSepcChange(row, res)">
                      <el-option v-for="(item, index) of row.specList" :value="item.specId" :label="item.specName"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column key="heihei2" v-else prop="specId" label="规格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.specId`" :rules="[{ required: true, message: '请选择规格' }]">
                    <!-- <el-select v-model="row.specId" clearable filterable
                      :placeholder="row.purchaseType ? '请选择规格' : '请先选择采购类型'" :disabled="!row.purchaseType">
                      <el-option v-for="(item, index) of row.specList"
                        :value="row.purchaseType == '1' ? item.specId : item.materialId"
                        :label="row.purchaseType == '1' ? item.specName : item.materialName" :key="index"></el-option>
                    </el-select> -->
                    <el-input readonly v-model="row.specName" @click.native="onSpecShow(row, onFormDataSpecChange)"
                      placeholder="请选择品种规格" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="deliveryPrice" :label="formData.orderType === '1' ? '结算单价' : '暂定单价'">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.deliveryPrice`"
                    :rules="[{ required: true, message: '请输入' + formData.orderType === '1' ? '结算单价' : '暂定单价' }]">
                    <el-input v-model="row.deliveryPrice"
                      :placeholder="'请输入' + + formData.orderType === '1' ? '结算单价' : '暂定单价'" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column v-if="orderType === '2'" label="父订单基差价格" prop="parentBasisPrice"></el-table-column>
              <el-table-column v-if="formData.orderType === '2'" prop="basisPrice" label="基差价格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.basisPrice`"
                    :rules="[{ required: true, message: '请输入基差价格' }]">
                    <el-input v-model="row.basisPrice" placeholder="请输入基差价格" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="purchaseQuantity" label="订单数量">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.purchaseQuantity`"
                    :rules="[{ required: true, message: '请输入订单数量' }]">
                    <el-input-number v-model="row.purchaseQuantity" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="{ $index }">
                  <el-button type="text" @click="deleteSpec($index)" class="del-btn">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>
  </div>
</template>

<script>
import { orderPrice, orderType, purchaseType, purchaserType } from '@/utils/dict'
import { deepClone } from '../../utils/utils'
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'purchaseOrdersAdd',
  components: {
    SpecChoose
  },
  data() {
    return {
      orderPriceMap: orderPrice,
      orderTypeMap: orderType,
      purchaseTypeMap: purchaseType,
      purchaserTypeMap: purchaserType,
      supplierList: [],
      userList: [],
      bidDucomentList: [],
      parentData: {}, // 字段同formData
      purchaserName: '',
      formData: {
        orderId: '', // 订单ID
        purchaserType: '',
        orderDeposit: '',
        purchaserCompany: '',
        orderParent: '1', // 父级订单id,1表示非子订单
        purchaser: '', // 采购方
        orderTitle: '', // 合同标题
        orderNum: '', // 合同编号
        supplierId: '', // 供应商ID
        orderPrice: '', // 付款方式1,100%付款2,110%付款
        orderType: '1', // 订单类型1一口价订单2基差订单
        fileList: [], // 附件列表
        specList: [] // 规格列表
      },
      rules: {
        orderTitle: [{ required: true, message: '请输入合同标题' }],
        orderNum: [{ required: true, message: '请输入合同编号' }],
        supplierId: [{ required: true, message: '请选择供应商' }],
        orderPrice: [{ required: true, message: '请选择付款方式' }],
        purchaserType: [{ required: true, message: '请选择采购类型' }],
        orderType: [{ required: true, message: '请选择订单类型' }],
        purchaser: [{ required: true, message: '请输入采购方' }],
        specList: [{ required: true, type: 'array', message: '请添加规格' }]
      },
      dialogVisible: false,
      currentRow: {},
      callback: null
    }
  },
  created() {
    if (this.orderParent) {
      this.formData.orderParent = this.orderParent
      this.formData.purchaser = this.purchaser
      this.formData.supplierId = this.supplierId
      this.formData.purchaserType = this.purchaserType
      this.loadParentData()
    }
    if (this.orderId) {
      this.loadData()
    }
    this.loadBidDucomentList()
    this.loadSupplierList()
    this.loadUserList()
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    orderId() {
      return this.$route.query.orderId
    },
    orderType() {
      return this.$route.query.orderType
    },
    // 父订单orderId
    orderParent() {
      return this.$route.query.orderParent
    },
    purchaser() {
      return this.$route.query.purchaser
    },
    supplierId() {
      return this.$route.query.supplierId
    },
    purchaserType() {
      return this.$route.query.purchaserType
    }
  },
  methods: {
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    onSpecShow(row, callback) {
      this.dialogVisible = true
      this.currentRow = row
      this.callback = callback
    },
    onSpecSelect(data) {
      this.callback(this.currentRow, data)
    },
    onFormDataSpecChange(row, data) {
      row.specName = data.specName
      row.specId = data.specId
    },
    onBidChange(bidId) {
      if (bidId) {
        this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentByBidId, {
          bidId
        }).then(res => {
          this.purchaserName = res.purchaserName
          this.formData.purchaser = res.purchaser
          this.formData.specList = res.specList
        })
      }
    },
    onChildSepcChange(row, val) {
      const data = row.specList.find(item => item.specId === val)
      row.purchaseType = data.purchaseType
      row.parentBasisPrice = data.basisPrice
    },
    loadBidDucomentList() {
      this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentByPage, {
        status: '3'
      }).then(res => {
        this.bidDucomentList = res.list || []
      })
    },
    loadSupplierList() {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierList = res || []
      })
    },
    loadParentData() {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByOrderId, {
        params: { orderId: this.orderParent }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        this.parentData = res || {}
      })
    },
    loadData() {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByOrderId, {
        params: { orderId: this.orderId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        this.formData = res || {}
      })
    },
    addSpecList() {
      const row = {
        specList: this.orderParent === '1' ? [] : this.parentData.specList,
        specId: '', // 规格id
        specName: '',
        deliveryPrice: '', // 暂定单价/结算单价
        basisPrice: '', // 基差价格
        parentBasisPrice: '',
        purchaseQuantity: '', // 订单数量
        purchaseType: '1' // 采购类型1粮油2物料
      }
      this.formData.specList.push(row)
    },
    deleteSpec(index) {
      this.formData.specList.splice(index, 1)
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.purchaseOrders.insertYcPurchaseOrder
        if (this.orderId) {
          url = this.$apis.purchaseOrders.updateYcPurchaseOrder
        }
        const formData = deepClone(this.formData)
        formData.specList.forEach(item => {
          delete item.specList
          delete item.parentBasisPrice
        })
        this.$axios.post(url, formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
